module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<legend>'+
((__t=( i18n.tc("Recipients", "Delete Recipient") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc( "Recpients", "Are you sure you want to delete the following recipient?" ) ))==null?'':__t)+
'</p><span class="block danger">'+
((__t=( recipientName ))==null?'':__t)+
'</span><fieldset class="button-wrap"><button data-click="recipient-delete-cancel">'+
((__t=( i18n.tc("Recipients", "Cancel") ))==null?'':__t)+
'</button> <button class="danger" data-click="recipient-delete-submit">'+
((__t=( i18n.tc("Recipients", "Delete") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
